__turbopack_context__.v({
  "arrow-button-next": "RecomendedSlider-module__SdqcRa__arrow-button-next",
  "arrow-button-prev": "RecomendedSlider-module__SdqcRa__arrow-button-prev",
  "card": "RecomendedSlider-module__SdqcRa__card",
  "card-image": "RecomendedSlider-module__SdqcRa__card-image",
  "card-title": "RecomendedSlider-module__SdqcRa__card-title",
  "disabled": "RecomendedSlider-module__SdqcRa__disabled",
  "image-wrapper": "RecomendedSlider-module__SdqcRa__image-wrapper",
  "recomended": "RecomendedSlider-module__SdqcRa__recomended",
});
